import { useState, useEffect } from 'react';
import Confetti from 'react-confetti';

interface ConfettiExplosionProps {
    duration?: number;
}

export default function ConfettiExplosion({ duration = 5000 }: ConfettiExplosionProps) {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });

        const handleResize = () => {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        const timer = setTimeout(() => setIsActive(false), duration);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timer);
        };
    }, [duration]);

    if (!isActive) return null;

    return (
        <Confetti
            width={dimensions.width}
            height={dimensions.height}
            recycle={false}
            numberOfPieces={500}
            gravity={0.3}
            colors={['#00FF00', '#9333EA', '#FF00FF', '#00FFFF', '#FFFFFF']}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 100,
                pointerEvents: 'none',
            }}
        />
    );
}
